import { usePublicSubscriptionPlans } from "@/hooks/useSubscriptionPlans"
import { buildLimitedAvailabilityPricingFaqAnswer } from "@/lib/plan-marketing-copy"
import { contactEmail } from "@/lib/site-links"

export function PricingFaqAnswer() {
  const plans = usePublicSubscriptionPlans()

  if (plans.isPending) {
    return <>Loading plan details…</>
  }

  if (plans.isError) {
    return (
      <>
        Every tier is free of charge while availability is limited. Billing has not launched yet — email {contactEmail} with
        questions.
      </>
    )
  }

  return <>{buildLimitedAvailabilityPricingFaqAnswer()}</>
}
